import { render } from "./DraggableCaption.vue?vue&type=template&id=14e61478&scoped=true"
import script from "./DraggableCaption.vue?vue&type=script&lang=js"
export * from "./DraggableCaption.vue?vue&type=script&lang=js"

import "./DraggableCaption.vue?vue&type=style&index=0&id=14e61478&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14e61478"

export default script